/**
 * Do not edit directly
 */

export default "PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEgMjFMMTcuNTAwMSAxNy41TTIwIDExLjVDMjAgMTYuMTk0NCAxNi4xOTQ0IDIwIDExLjUgMjBDNi44MDU1OCAyMCAzIDE2LjE5NDQgMyAxMS41QzMgNi44MDU1OCA2LjgwNTU4IDMgMTEuNSAzQzE2LjE5NDQgMyAyMCA2LjgwNTU4IDIwIDExLjVaIiBzdHJva2U9ImJsYWNrIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz48L3N2Zz4=";